import { Control, Controller } from "react-hook-form";
import { FormControl, InputLabel } from "@mui/material";
import React, { useState } from "react";

import { CalendarEditIcon } from "../../Icons";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { InputCustom } from "../../../styles/styledComponents";

interface DatePickerControllerProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  disabled?: boolean;
  disableFuture?: boolean;
  minDate?: Date;
  maxDate?: Date;
  edit?: Boolean;
  className?: string;
}

const DatePickerController = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  disabled = false,
  disableFuture = false,
  minDate,
  maxDate,
  edit,
  className,
}: DatePickerControllerProps) => {
  const fieldId = id || name;
  const [error, setError] = useState<string | null>();

  return (
    <FormControl fullWidth={fullWidth}>
      {label &&
        <InputLabel htmlFor={fieldId} className={`${className}`} >{label}</InputLabel>
      }
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) =>
          <DesktopDatePicker
            {...field}
            inputFormat="MM/dd/yyyy"
            disableFuture={disableFuture}
            minDate={minDate}
            maxDate={maxDate}
            components={{
              OpenPickerIcon: edit ? CalendarEditIcon : undefined,
            }}
            renderInput={(params) =>
              <InputCustom
                id={fieldId}
                disabled={disabled}
                sx={{ width: "100%" }}
                {...params}
                error={!!fieldState.error || !!error}
              />}
            onError={setError}
          />
        }
      />
    </FormControl>
  );
};

export default DatePickerController;
